import {State} from '../store';
import {PageDescription} from './actions';

export const getCurrentLocation = (state: State) => state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname;

export const isCurrentLocation = (state: State, location: PageDescription) => getCurrentLocation(state) === location.url;
